<div class="container-fluid">
    <div class="row top10 no-gutters">
        <div class="col-xs-12 col-md-6 vcenter">
            <h4>Edit Company Sites</h4>
        </div>
        <div class="col-xs-12 col-md-6  vcenter-right">
            <div>
            </div>
        </div>
    </div>

    <hr style="margin-top:2px;margin-bottom:2px" />

    <aims-common-table
        id="config-sites-table"
        [dataSource]="sites | async"
        [header]="header"
        [pageSize]="10"
        [permissions]="tablePermissions"
        [addRowInitialObject]="initialTableElement"
        (rowUpdated)="handleRowUpdate($event)"
        (rowAdded)="handleRowAdd($event)"
        >
        <aims-common-table-dynamic-row id="active">
            <ng-template viewMode let-element>
                <div class="fullWidth text-center">
                    <mat-checkbox [checked]="element.active" disabled></mat-checkbox>
                </div>
            </ng-template>
            <ng-template editMode let-element let-idx="idx" let-dynamicControl="dynamicControl" let-formGroup="formGroup">
                <div class="fullWidth text-center">
                    <mat-checkbox [formControl]="dynamicControl"></mat-checkbox>
                </div>
            </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="hasFastPlant">
            <ng-template viewMode let-element>
                <div class="fullWidth text-center">
                    <mat-checkbox [checked]="element.hasFastPlant" disabled></mat-checkbox>
                </div>
            </ng-template>
            <ng-template editMode let-element let-idx="idx" let-dynamicControl="dynamicControl">
                <div class="fullWidth text-center">
                    <mat-checkbox [formControl]="dynamicControl" ></mat-checkbox>
                </div>
            </ng-template>
        </aims-common-table-dynamic-row>
    </aims-common-table>
</div>
